import TtamIdentityType from './type/index.vue';
import TtamIdentityTypeTips from './type-tips/index.vue';
import TtamIdentityCustomCreateAvatar from './custom-create/avatar.vue';
import TtamIdentityCustomCreateName from './custom-create/name.vue';
import TtamIdentityCustomCreateButton from './custom-create/button.vue';
import TtamIdentityCustomList from './custom-list/index.vue';
import TtamIdentityTiktokList from './tiktok-list/index.vue';
import TtamIdentitySaleTiktokList from './sale-tiktok-list/index.vue';
import TtamIdentityTiktokPostAuthorizeButton from './tiktok-post-authorize/button.vue';
import TtamIdentityTiktokPostAuthorizeGuide from './tiktok-post-authorize/guide.vue';
import TtamIdentityTiktokPostAuthorizePreview from './tiktok-post-authorize/preview.vue';
import TtamIdentityTiktokPostAuthorizeSearchInput from './tiktok-post-authorize/search-input.vue';
import TtamIdentityTiktokPostAuthorizeCodeDisplay from './tiktok-post-authorize/code-display.vue';
import TtamIdentityTiktokTypeSelect from './tiktok-type-select/index.vue';
import TtamIdentityTiktokAccountPopover from './tiktok-account-popover/index.vue';
import TtamIdentityTiktokAccount from './tiktok-account/index.vue';
import TtamIdentityTiktokTips from './tiktok-tips/index.vue';
import TtamIdentityErrorTips from './error-tips/index.vue';
import TtamTiktokIdentityDisplay from './tiktok-identity-display/index.vue';
import TtamIdentityListItemDeleteModal from './common/delete-modal.vue';
import TtamIdentityTiktokPostAuthorizeDialog from './native-authorization/index.vue';
import * as hooks from './hooks';
import * as contants from './const';

import { useIdentityPageList } from './hooks/use-identity-page-list';
import { useIdentityDisplayList } from './affiliate-identity-select-popover/hooks';

export default {
  ...hooks,
  ...contants,
  useIdentityPageList,
  useIdentityDisplayList,

  TtamIdentityType,
  TtamIdentityTypeTips,
  TtamIdentityErrorTips,
  TtamIdentityCustomList,
  TtamIdentityTiktokList,
  TtamIdentityTiktokTips,
  TtamIdentityTiktokAccount,
  TtamIdentitySaleTiktokList,
  TtamIdentityTiktokTypeSelect,
  TtamIdentityTiktokAccountPopover,
  TtamIdentityTiktokPostAuthorizeGuide,
  TtamIdentityTiktokPostAuthorizeButton,
  TtamIdentityTiktokPostAuthorizePreview,
  TtamIdentityTiktokPostAuthorizeCodeDisplay,
  TtamIdentityTiktokPostAuthorizeSearchInput,
  TtamIdentityCustomCreateName,
  TtamIdentityCustomCreateAvatar,
  TtamIdentityCustomCreateButton,
  TtamTiktokIdentityDisplay,
  TtamIdentityListItemDeleteModal,
  TtamIdentityTiktokPostAuthorizeDialog,
};
